import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'

Vue.use(VueScrollTo)

export default el => Promise.all([
  enqueueModule('text-input.vue'),
  enqueueModule('checkbox.vue')
]).then(() => new Vue({
  el,
  data () {
    return {
      activeAddress: {},
      showNewAddressForm: false,
      hideFormTitle: false,
      formPosition: -1
    }
  },
  methods: {
    toggleNewAddressForm (show) {
      this.showNewAddressForm = show

      if (this.activeAddress.address1) {
        this.hideFormTitle = true
      } else {
        this.hideFormTitle = false
        this.formPosition = -1
      }

      show && this.$nextTick(() => {
        this.$scrollTo(this.$refs.newAddressForm)
        this.$refs.mainForm.style.order = this.formPosition
      })
    },
    populateAddressForm (data) {
      this.activeAddress = data[0]
      this.formPosition = data[1]
      this.toggleNewAddressForm(true)
    },
    showEmptyForm () {
      for (const key in this.activeAddress) {
        this.activeAddress[key] = ''
      }
      this.toggleNewAddressForm(true)
    }
  }
}))
